<p-tabView [(activeIndex)]="index" (onChange)="getIndex($event)">
    <p-tabPanel header="Type">
     <app-type [typesList]="allInventoryTypes" [typeConfig]="inventoryTypeConfig"></app-type>
    </p-tabPanel>
    <p-tabPanel header="Category">
      @if(index==1){
        <app-category></app-category>
      }
    </p-tabPanel>
    <p-tabPanel header="Template">
      <app-template [allSections]="allInventorySections" [templates]="allInventoryTemplates" [templateConfig]="inventoryTypeTemplateConfig"></app-template>
    </p-tabPanel>
    <p-tabPanel header="Fields">
      @if(index==3){
        <app-fields></app-fields>
      }
    </p-tabPanel>
    <p-tabPanel header="Products Visibility" *ngIf="visibilityStatus">
      @if(index==4){
      <app-visibility [index]="index" [displayAddGroup]="displayAddGroup" (closeDialog)="closeDialog()"></app-visibility>
      }
    </p-tabPanel>
    <!-- <p-tabPanel header="Products Visibility">
      <app-visibility></app-visibility>
    </p-tabPanel>
    <p-tabPanel header="Tags">
      <app-tags></app-tags>
    </p-tabPanel> -->
    <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
      <ng-template pTemplate="header">
        <p-menu #configmenuInventory id="config_menu_inventory" [model]="configMenuInventoryItems"
          [popup]="true" appendTo="body">
        </p-menu>
        <span class="btnBars p-mr-0" (click)="configmenuInventory.toggle($event)">
          <i class="pi pi-bars"></i>
        </span>
      </ng-template>
    </p-tabPanel>
  </p-tabView>